// 获取企微后台登录地址
// https://iwiki.woa.com/pages/viewpage.action?pageId=637658397#id-%E8%B4%A6%E6%88%B7%E4%B8%AD%E5%BF%83%E5%91%98%E5%B7%A5%E6%9C%8D%E5%8A%A1%E5%BA%94%E7%94%A8%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3-%E6%9F%A5%E8%AF%A2%E4%BC%81%E5%BE%AE%E7%9B%B8%E5%85%B3%E4%BF%A1%E6%81%AF

import { isPrivate } from '@/config/private';
import Gateway from 'src/utils/Gateway';

// eslint-disable-next-line import/prefer-default-export
export function getWeorkLoginPage() {
    if (isPrivate) {
        return Gateway.get('/v1/wework/staff/weworkInfo').then((data) => {
            const { url } = data || {};
            return url;
        });
    }

    return Promise.resolve('https://work.weixin.qq.com/wework_admin/loginpage_wx');
}
